import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { checkDuplicates, } from "../infrastructure/adapters/organisationService";
import { logger } from "../../../infrastructure/services/LoggerService";
export const DEDUP_PANEL_MAX = 6;
export function useDeduplication() {
    const { t } = useI18n();
    const dedupState = ref("initialHint");
    const dedupResults = ref([]);
    const dedupTitle = computed(() => {
        if (dedupState.value === "noDuplicate")
            return t("organisation.create.dedup.noDuplicate");
        if (dedupState.value === "duplicateFound")
            return t("organisation.create.dedup.duplicateFound", { count: dedupResults.value.length });
        if (dedupState.value === "similarFound")
            return t("organisation.create.dedup.similarFound", { count: dedupResults.value.length });
        return t("organisation.create.dedup.title");
    });
    const dedupHint = computed(() => {
        switch (dedupState.value) {
            case "initialHint":
                return t("organisation.create.dedup.initialHint");
            case "checking":
                return t("organisation.create.dedup.checking");
            case "noDuplicate":
                return t("organisation.create.dedup.noDuplicateHint");
            case "duplicateFound":
                return t("organisation.create.dedup.duplicateHint");
            case "similarFound":
                return t("organisation.create.dedup.similarHint");
            default:
                return "";
        }
    });
    async function runDeduplication(payload) {
        if (!payload.legalName &&
            !payload.primaryRegistrationNumber &&
            !payload.domainName &&
            !payload.city)
            return;
        dedupState.value = "checking";
        dedupResults.value = [];
        try {
            const results = await checkDuplicates(payload);
            dedupResults.value = results;
            if (results.length === 0) {
                dedupState.value = "noDuplicate";
            }
            else if (results.some((r) => r.similarityScore === 100)) {
                dedupState.value = "duplicateFound";
            }
            else {
                dedupState.value = "similarFound";
            }
        }
        catch (error) {
            logger.error("Duplicate check failed", error);
            dedupState.value = "initialHint";
            dedupResults.value = [];
        }
    }
    function reset() {
        dedupState.value = "initialHint";
        dedupResults.value = [];
    }
    return { dedupState, dedupResults, dedupTitle, dedupHint, runDeduplication, reset };
}
